import EditButtonGroup from "../EditButton/EditButtonGroup";
import { Button } from "components/Button/Button";
import "./ChangeList.scss";

const ChangeList = ({ changes = [], onEditField, onUndoField, handleOpenDiscardModal }) => {
	return (
		<div className={"change-list"}>
			<h1>Current Changes{" "}</h1>

			{Array.isArray(changes) && changes.length > 0 ? (
				<>
					{changes.map((block) => (
						<div key={`${block.scope}-${block.id}`} className="change-list-block">
							<p className="change-list-header">
								+ {block.scope} {block.action} -{" "}
								<span className="change-list-header-name">{block.name}</span>
							</p>

							{Array.isArray(block.changes) &&
								block.changes.map((change, index) => {
									const isMissing = change.label.toLowerCase().includes("missing");
									return (
										<div
											key={`${block.id}-${index}`}
											className={`change-list-item ${isMissing ? "is-missing" : ""}`}
										>
											<p className="change-list-item-text">{change.label}</p>
											{change.field && (
												<span className="change-list-item-undo" style={{ marginLeft: 8 }}>
													<EditButtonGroup
														showEdit={isMissing}
														showUndo={!isMissing}
														onEdit={() => onEditField(block.scope, block.id, change.field)}
														onUndo={() => onUndoField(block.scope, block.id, block.parentId, change.field)}
													/>
												</span>
											)}
										</div>
									);
								})}
						</div>
					))}
					<div className="discard-button">
						<Button text="Discard Current Changes" onClick={handleOpenDiscardModal} />
					</div>
				</>
			) : (
				<p>No unpublished changes detected.</p>
			)}
		</div>
	);
};

export default ChangeList;
